export class AMTC{
    id?: any=null;
    person_id?: any = null;
    assmt_year?: any = null;
    gross_b1?: any = null;
    credit_utilised_b2?: any  = null; 
    credit_carried_forward_b3?: any  = null;
    set_off_in_earlier_c?: any  = null;
    balance_budget_forward_d?: any  = null;
    date_created?: any  = null;
    date_updated?: any  = null;
}


export class AMTCMain{
    id?: any=null;
    person_id?: any=null;
    financial_id?: any=null;
    amtc1?: any=null;
    amtc2?: any=null;
    amtc3?: any=null;
    amtc4_b1?: any=null;
    amtc4_b2?: any=null;
    amtc4_b3?: any=null;
    amtc4_c?: any=null;
    amtc4_d?: any=null;
    amtc5?: any=null;
    amtc6?: any=null;
    amtc7?: any=null;
    amtc8?: any=null;
    date_created?: any  = null;
    date_updated?: any  = null;
    mode?:boolean = true;
    assmt_years: AMTC[]  = [];
}